import "../style.css";
import Modal from "components/Modal";
import { useAuthStore } from "stores/auth/authStore";
import ForgotPasswordForm from "components/Forms/ForgotPasswordForm";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";

export const ForgotPasswordModal = () => {
  const close = useModalStore((s) => s.close);
  const current = useModalStore((s) => s.current);
  const isOpen = current === ModalKey.ForgotPassword;
  const toggleNewPassword = useAuthStore(action => action.toggleNewPassword);
  const toggleRepeatNewPassword = useAuthStore(action => action.toggleRepeatNewPassword);

  return (
    <Modal
      isCloseIcon
      shouldCloseOnOverlayClick={false}
      modalIsOpen={isOpen}
      closeModal={() => {
        close();
        toggleNewPassword();
        toggleRepeatNewPassword();
      }}
      title={"Forgot password?"}
      className="p-10"
    >
      {{
        content: <ForgotPasswordForm />,
      }}
    </Modal>
  );
};

export default ForgotPasswordModal;
